"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    color: ", ";\n    background: ", ";\n    padding-top: ", "em;\n    transition: ", ";\n    position: absolute;\n\n    right: ", ";\n\n    ", ";\n"], ["\n    width: 100%;\n    height: 100%;\n    color: ", ";\n    background: ", ";\n    padding-top: ", "em;\n    transition: ", ";\n    position: absolute;\n\n    right: ", ";\n\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n            overflow: hidden;\n        "], ["\n            overflow: hidden;\n        "]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var position = function position(props) {
    if (props.current == props.i) {
        return "0";
    }
    if (props.current > props.i) {
        return "100%";
    }
    if (props.current < props.i) {
        return "-100%";
    }
};

var doesAnimate = function doesAnimate(props) {
    if (props.first || props.last) {
        return true;
    } else if (props.current < props.i && props.direction == "right" || props.current > props.i && props.direction == "left") {
        return false;
    } else {
        return true;
    }
};

var CarouselItem = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.carousel.item.color;
}, function (props) {
    return props.theme.carousel.item.background;
}, function (props) {
    return props.theme.carousel.item.padding;
}, function (props) {
    return doesAnimate(props) ? "right 500ms linear" : "none";
}, function (props) {
    return position(props);
}, function (props) {
    return props.current != props.i && (0, _styledComponents.css)(_templateObject2);
});

CarouselItem.displayName = "CarouselItem";

CarouselItem.propTypes = {
    i: _propTypes2.default.number
};

CarouselItem.defaultProps = {};

exports.default = CarouselItem;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/carousel/carouselItem.js
// module id = 451
// module chunks = 95715928098905 168707334958949